import { NavLink } from 'react-router-dom'
import { useState } from 'react'

const links = [
  ['/', 'Home'],
  ['/demo', 'Demo'],
  ['/integrations', 'Integrations'],
  ['/about', 'About us'],
  ['/community', 'Community'],
] as const

export default function SiteHeader() {
  const [open, setOpen] = useState(false)

  return (
    <header className="site-header">
      <div>
        <NavLink className="wordmark" to="/" onClick={() => setOpen(false)}>
          Road Stack.
        </NavLink>
        <p className="tagline">Hardware, telemetry, workflows, all inside the cockpit.</p>
      </div>
      <button
        className="menu-button"
        type="button"
        aria-expanded={open}
        aria-controls="primary-navigation"
        onClick={() => setOpen((current) => !current)}
      >
        <span className="sr-only">Toggle navigation</span>
        <span aria-hidden="true">{open ? 'Close' : 'Menu'}</span>
      </button>
      <nav
        id="primary-navigation"
        className={open ? 'site-nav site-nav--open' : 'site-nav'}
        aria-label="Primary navigation"
      >
        {links.map(([to, label], index) => (
          <span className="nav-item" key={to}>
            {index > 0 && <span className="nav-divider" aria-hidden="true">|</span>}
            <NavLink
              to={to}
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {label}
            </NavLink>
          </span>
        ))}
      </nav>
    </header>
  )
}
